import React from "react";
import { Link } from 'react-router-dom';

import './Navbar.css';

const Navbar = () => {
  return (
    <div className="navbar bg-base-100">
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
          </div>
        </div>
        <Link to="/" className="btn btn-ghost text-xl">outcomes.fyi</Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li><a href = '/'>All Bootcamps</a></li>
          <li>
            <details>
              <summary>View Bootcamps</summary>
              <ul className="p-2">
                <li className ="submenu"><a href = '/'>Submenu 1</a></li>
                <li className="submenu"><a href = '/'>Submenu 2</a></li>
              </ul>
            </details>
          </li>
        </ul>
      </div>

      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li><Link to='/' className="menu-item">All Companies</Link></li>
          <li>
            <details>
              <summary>View Companies</summary>
              <ul className="p-2">
                <li className ="submenu"><a href = '/'>Submenu 1</a></li>
                <li className="submenu"><a href = '/'>Submenu 2</a></li>
              </ul>
            </details>
          </li>
        </ul>
      </div>

      <div className="navbar-end">
      <Link to="/newoutcome" className="btn">Recent Grad? Click Here</Link>
      </div>
    </div>
  );
}

export default Navbar;